import React from 'react';
import Donations from './donations.jsx';

const Index = () => {

	return(

		<Donations />

	)

}

export default Index;